import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, OFFER_ANCHOR } from '../data/fono';
export function Hero() {
  return <section className="bg-teal px-3 py-5 text-center sm:py-7" data-id="element-80" data-mp="eiboxjpyos8e">
      <div className="mx-auto max-w-3xl" data-id="element-81" data-mp="9ka2qpx8ocsp">
        <p className="mx-auto mb-2 inline-block rounded border border-turq/70 bg-turq/20 px-2.5 py-1 text-[9px] font-extrabold uppercase tracking-[0.14em] text-mint sm:text-[11px]" data-id="element-82" data-mp="9l34tdl96e4i">
          Speech • Language • Vocabulary • Phonological Awareness • Auditory • Narrative
        </p>

        <h1 className="text-[26px] leading-[1.02] text-white sm:text-4xl md:text-[44px]" data-id="element-83" data-mp="xbpbb0flzqce">
          The Complete Ready-To-Use Activity System
          <span className="block text-mustard" data-id="element-84" data-mp="nc88qrvnlskn">
            for Pediatric Speech-Language Professionals
          </span>
        </h1>

        <p className="mx-auto mt-2 max-w-2xl text-[13px] font-semibold leading-snug text-white sm:text-base" data-id="element-85" data-mp="3d1sakxd0hjt4">
          Stop spending hours searching for, creating and rebuilding materials before every
          session.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-[13px] font-medium leading-snug text-mint sm:text-base" data-id="element-86" data-mp="3j9ainhg5sy79">
          Get visual activities, printable cards, games, picture scenes, sorting resources,
          phonological awareness materials, auditory activities and narrative tools —
          organized in one professional system.
        </p>

        <a href={OFFER_ANCHOR} className="mt-3 block" data-id="element-87" data-mp="30iayquniueku">
          <img src={BOX_IMAGE} alt="FONO KIDS PRO™ complete 6-in-1 visual activity system" className="mx-auto w-full max-w-[300px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02] sm:max-w-md" data-id="element-88" data-mp="30gq6jbooj7q5" />
        </a>

        <CTAButton className="mx-auto mt-3 max-w-md" data-id="element-89" data-mp="2vjpvemcz3es6">
          🗣️ YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="mt-1.5 text-[11px] font-bold text-mint sm:text-sm" data-id="element-90" data-mp="2hl9sz7m58afu">
          🛡️ 30-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}